import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function ContractSection() {
  return (
    <section id="contract-section" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14 reveal">
          <SectionLabel label={pricingData.contract.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {pricingData.contract.title}
          </h2>
        </div>

        <div className="reveal bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8 mb-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3">
            {pricingData.contract.items.map((item, i) => (
              <div key={i} className="flex items-center gap-3 py-2">
                <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-primary-600 text-xs`} />
                </div>
                <span className="text-sm md:text-base text-foreground-700">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="reveal text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-background-50 border border-background-200/70">
            <i className="ri-information-line text-primary-500" />
            <p className="text-sm text-foreground-600">{pricingData.contract.note}</p>
          </div>
        </div>
      </div>
    </section>
  );
}